module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open) ? _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("New " + _vm._s(_vm.type))]), _vm._v(" "), _vm._t("default")], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae8c3faa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/EditTable/new-item.vue
// module id = 653
// module chunks = 30